import { fetchEventSource } from '@microsoft/fetch-event-source'
import { Client } from '@modelcontextprotocol/sdk/client/index.js'
import { StreamableHTTPClientTransport } from '@modelcontextprotocol/sdk/client/streamableHttp.js'
import request from '../utils/request'
const baseUrl = STREAMS_API_URL

function getSystemInfo() {
  return request('/info', {
    method: 'get'
  })
}

function putSystemInfo(data) {
  return request(`/system/info`, {
    method: 'put',
    data
  })
}

function initializeSystem(data) {
  return request('/init', {
    method: 'post',
    data
  })
}

function querySubjects(query) {
  return request('/subject/query', {
    method: 'post',
    data: query
  })
}

function loadSubjects() {
  return request('/subject', {
    method: 'get'
  })
}

function loadSubject(name) {
  return request(`/subject/${name}`, {
    method: 'get'
  })
}

function removeSubject(name, force = false) {
  return request(`/subject/${name}${force ? '?force=1' : ''}`, {
    method: 'delete'
  })
}

function restoreSubject(name) {
  return request(`/subject/${name}/restore`, {
    method: 'put'
  })
}

function updateSubject(name, data = {}) {
  return request(`/subject/${name}`, {
    method: 'put',
    data
  })
}

function createSubject(params = {}, preview = false) {
  console.log(params)
  return request('/subject?preview=' + preview, {
    method: 'post',
    data: params
  })
}

function getSubjectField(name) {
  return request(`/subject/${name}/field`, {
    method: 'get'
  })
}

function deleteSubjectField(subjectName, fieldName) {
  return request(`/subject/${subjectName}/field/${fieldName}`, {
    method: 'delete'
  })
}

function updateSubjectField(subjectName, fieldName, params = {}) {
  return request(`/subject/${subjectName}/field/${fieldName}`, {
    method: 'put',
    data: params
  })
}

function addSubjectField(subjectName, params = {}) {
  return request(`/subject/${subjectName}/field`, {
    method: 'post',
    data: params
  })
}

function reorderSubjectField(subjectName, params = {}) {
  return request(`/subject/${subjectName}/field/reorder`, {
    method: 'put',
    data: params
  })
}

function importSubjectFields(subjectName, params = {}) {
  return request(`/subject/${subjectName}/field/import`, {
    method: 'put',
    data: params
  })
}

function getSubjectIndex(subjectName) {
  return request(`/search/index/${subjectName}`, {
    method: 'get'
  })
}

function refreshSubjectIndex(subjectName) {
  return request(`/search/index/${subjectName}/refresh`, {
    method: 'put'
  })
}

function getSubjectView(subjectName) {
  return request(`/subject/${subjectName}/view`, {
    method: 'get'
  })
}

function getSubjectViewDetail(subjectName, viewName) {
  return request(`/subject/${subjectName}/view/${viewName}`, {
    method: 'get'
  })
}

function createSubjectView(subjectName, query) {
  return request(`/subject/${subjectName}/view`, {
    method: 'post',
    data: query
  })
}

function updateSubjectView(subjectName, viewName, query) {
  return request(`/subject/${subjectName}/view/${viewName}`, {
    method: 'put',
    data: query
  })
}

function deleteSubjectView(subjectName, viewName) {
  return request(`/subject/${subjectName}/view/${viewName}`, {
    method: 'delete'
  })
}
function reorderSubjectView(subjectName, params = {}) {
  return request(`/subject/${subjectName}/view/reorder`, {
    method: 'put',
    data: params
  })
}

function changeSearchIndex(params) {
  return request('/search/change/index', {
    method: 'POST',
    data: params
  })
}

function loadRecord(name) {
  return request(`/record/${name}`, {
    method: 'get'
  })
}

function loadRecordRevisions(name, page = 0, pageSize = 20) {
  return request(
    `/record/${name}/revision?page=${page}&page_size=${pageSize}`,
    {
      method: 'get'
    }
  )
}

function applyRecordRevision(name, version) {
  return request(`/record/${name}/revision`, {
    method: 'put',
    data: {
      version
    }
  })
}

function proxyGet(url) {
  return request(`/proxy?url=${encodeURIComponent(url)}`, {
    method: 'get'
  })
}

function loadRecords(
  subjectName,
  page = 0,
  page_size = 20,
  filter = {},
  sort = null,
  keyword = null,
  full = false,
  select = null
) {
  return request('/record/query', {
    method: 'post',
    data: {
      subject: subjectName,
      sort: sort,
      page,
      page_size,
      filter,
      keyword,
      full,
      select
    }
  })
}

function queryRecords(query) {
  return request('/record/query', {
    method: 'post',
    data: query
  })
}

function countRecords(query) {
  return request('/record/count', {
    method: 'post',
    data: query
  })
}

function queryRemovedRecord(
  page = 0,
  page_size = 20,
  filter = {},
  keyword = null
) {
  return request('/record/query/removed', {
    method: 'post',
    data: {
      page,
      page_size,
      filter,
      keyword
    }
  })
}

function aggregateRecords(aggregation) {
  return request('/record/aggregate', {
    method: 'post',
    data: aggregation
  })
}

function reorderRecords(params) {
  return request('/record/reorder', {
    method: 'POST',
    data: params
  })
}

function search(index, query) {
  return request(`/search?index=${index}`, {
    method: 'post',
    data: query
  })
}

function commonSearch(
  keyword,
  index = '*',
  page = 0,
  pageSize = 5,
  exact = true
) {
  return request(
    `/search/common?keyword=${keyword}&index=${index}&page=${page}&page_size=${pageSize}&exact=${exact}`
  )
}

function aggregateSearch(keyword, index = '*', page = 0, pageSize = 5) {
  return request(
    `/search/aggregate?keyword=${keyword}&index=${index}&page=${page}&page_size=${pageSize}`
  )
}

function subjectSearch(subject, query) {
  return request(`/search/${subject}`, {
    method: 'post',
    data: query
  })
}

function vectorSearch(subject, query) {
  return request(`/search/vector?index=${subject}`, {
    method: 'post',
    data: query
  })
}

// 阿里云 词库完善
function queryAnalyze(data) {
  return request(`/search/service/query-analyze`, {
    method: 'post',
    data
  })
}

function documentAnalyze(data) {
  return request(`/search/service/document-analyze`, {
    method: 'post',
    data
  })
}

function imageAnalyze(data) {
  return request(`/search/service/image-analyze`, {
    method: 'post',
    data
  })
}

function documentRerank(data) {
  return request(`/search/service/document-rerank`, {
    method: 'post',
    data
  })
}

function webSearch(data) {
  return request(`/search/service/web-search`, {
    method: 'post',
    data
  })
}

function rrfSearch(subject, query) {
  return request(`/search/vector_rff?index=${subject}`, {
    method: 'post',
    data: query
  })
}

function semanticSearch(subject, query) {
  return request(`/search/semantic?index=${subject}`, {
    method: 'post',
    data: query
  })
}

function langChainChat(req, onmessage) {
  const ctrl = new AbortController()
  return fetchEventSource(`${baseUrl}/ollama/langchain/chat`, {
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(req),
    onmessage: res => onmessage?.(res.data && JSON.parse(res.data))
  })
}

function langChainChatWithRag(req, onmessage) {
  const ctrl = new AbortController()
  return fetchEventSource(`${baseUrl}/ollama/langchain/chatWithRag`, {
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(req),
    onmessage: res => onmessage?.(res.data && JSON.parse(res.data))
  })
}

function ollamaChat(data) {
  return fetch(`${baseUrl}/ollama/chat`, {
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
}

function llmList() {
  return request('/llm/list', {
    method: 'get'
  })
}

function llmChat(data, signal = null) {
  return fetch(`${baseUrl}/llm/chat`, {
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    signal,
    body: JSON.stringify(data)
  })
}

function ollamaList() {
  return request(`/ollama/list`, {
    method: 'post'
  })
}

function ollamaPull(data, onmessage) {
  return fetchEventSource(`${baseUrl}/ollama/pull`, {
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data),
    onmessage
  })
}

function ollamaShow(model) {
  return request(`/ollama/show`, {
    method: 'post',
    data: {
      model
    }
  })
}

function ollamaRemove(model) {
  return request(`/ollama/delete`, {
    method: 'post',
    data: {
      model
    }
  })
}

function createRecord(params, preview = false) {
  return request('/record?preview=' + preview, {
    method: 'post',
    data: params
  })
}

function removeRecord(name, force = false) {
  return request(`/record/${name}${force ? '?force=1' : ''}`, {
    method: 'delete'
  })
}

function restoreRecord(name) {
  return request(`/record/${name}/restore`, {
    method: 'put'
  })
}

function updateRecord(name, model = {}) {
  return request(`/record/${name}`, {
    method: 'put',
    data: model
  })
}

function patchRecord(name, model = {}) {
  return request(`/record/${name}`, {
    method: 'patch',
    data: model
  })
}

function cloneRecord(name) {
  return request('/record/clone', {
    method: 'post',
    data: {
      from: name
    }
  })
}

function importRecords(subject, records) {
  return request(`/record/import`, {
    method: 'post',
    data: {
      subject,
      records
    }
  })
}

function clearRecords(subject) {
  return request(`/record/clear?subject=${subject}`, {
    method: 'delete'
  })
}

function batchCreateRecords(data) {
  return request(`/record/batch/create`, {
    method: 'post',
    data
  })
}

function batchUpdateRecords(data) {
  return request(`/record/batch/update`, {
    method: 'post',
    data
  })
}

function batchRemoveRecords(data) {
  return request(`/record/batch/remove`, {
    method: 'post',
    data
  })
}

function getRecordMembers(name) {
  return request(`/record/${name}/member`, {
    method: 'get'
  })
}

function createRecordMember(name, data) {
  return request(`/record/${name}/member`, {
    method: 'post',
    data
  })
}

function updateRecordMember(name, owner, data) {
  return request(`/record/${name}/member/${owner}`, {
    method: 'put',
    data
  })
}

function removeRecordMember(name, owner) {
  return request(`/record/${name}/member/${owner}`, {
    method: 'delete'
  })
}

// file
function queryDocuments(page, page_size, filter = {}, status) {
  return request('/document/query', {
    method: 'post',
    data: {
      page,
      page_size,
      filter,
      status
    }
  })
}

function getDocument(name) {
  return request(`/document/${name}`, {
    method: 'get'
  })
}

function removeDocument(name, force = false) {
  return request(`/document/${name}${force ? '?force=1' : ''}`, {
    method: 'delete'
  })
}

function restoreDocument(name) {
  return request(`/document/${name}/restore`, {
    method: 'put'
  })
}

function updateDocument(name, data) {
  return request(`/document/${name}`, {
    method: 'put',
    data
  })
}

function createDocument(formData) {
  return request('/document', {
    method: 'post',
    requestType: 'form',
    body: formData
  })
}

function uploadDocument(file) {
  let formData = new FormData()
  const filename = file.name
  const title = filename.split('.')[0]

  formData.set('title', title)
  formData.append('file', file)

  return createDocument(formData)
}

function uploadFile(file) {
  let formData = new FormData()
  formData.append('file', file)

  return request('/upload', {
    method: 'post',
    requestType: 'form',
    body: formData
  })
}

function parseDocument(formData) {
  return request('/parser/document/parse', {
    method: 'POST',
    requestType: 'form',
    body: formData
  })
}

// user
function queryUsers(page, page_size, filter = {}, status = null) {
  return request('/user/query', {
    method: 'post',
    data: {
      page,
      page_size,
      filter,
      status
    }
  })
}

function loadUser(name) {
  return request(`/user/${name}`, {
    method: 'get'
  })
}

function createUser(data) {
  return request(`/user`, {
    method: 'post',
    data
  })
}

function removeUser(name) {
  return request(`/user/${name}`, {
    method: 'delete'
  })
}

function updateUser(name, data) {
  return request(`/user/${name}`, {
    method: 'put',
    data
  })
}

function enableUser(name) {
  return request(`/user/${name}/enable`, {
    method: 'put'
  })
}

function disableUser(name) {
  return request(`/user/${name}/disable`, {
    method: 'put'
  })
}

function generateTicket(name) {
  return request(`/user/${name}/ticket`, {
    method: 'put'
  })
}

function importUsers(data) {
  return request(`/user/import`, {
    method: 'post',
    data
  })
}

function getUserInfo() {
  return request(`/user/info`, {
    method: 'get'
  })
}

function putUserInfo(data) {
  return request(`/user/info`, {
    method: 'put',
    data
  })
}

function changePassword(data) {
  return request(`/user/password/change`, {
    method: 'put',
    data
  })
}

// group
function queryGroups(query) {
  return request('/user/group/query', {
    method: 'post',
    data: query
  })
}

function getGroup(name) {
  return request(`/user/group/${name}`, {
    method: 'get'
  })
}

function createGroup(data) {
  return request(`/user/group`, {
    method: 'post',
    data
  })
}

function updateGroup(name, data) {
  return request(`/user/group/${name}`, {
    method: 'put',
    data
  })
}

function removeGroup(name) {
  return request(`/user/group/${name}`, {
    method: 'delete'
  })
}

function addGroupUser(group, user) {
  return request(`/user/group/${group}/${user}`, {
    method: 'put'
  })
}

function removeGroupUser(group, user) {
  return request(`/user/group/${group}/${user}`, {
    method: 'delete'
  })
}

// application
function getApplications() {
  return request('/application/info', {
    method: 'get'
  })
}

function queryApplications(page, page_size, filter = {}, status) {
  return request('/application/query', {
    method: 'post',
    data: {
      page,
      page_size,
      filter,
      status
    }
  })
}

function loadApplication(name) {
  return request(`/application/${name}`, {
    method: 'get'
  })
}

function removeApplication(name, force = false) {
  return request(`/application/${name}${force ? '?force=1' : ''}`, {
    method: 'delete'
  })
}

function restoreApplication(name) {
  return request(`/application/${name}/restore`, {
    method: 'put'
  })
}

function updateApplication(name, data) {
  return request(`/application/${name}`, {
    method: 'put',
    data
  })
}

function createApplication(data) {
  return request('/application', {
    method: 'post',
    data
  })
}

function changeApplicationRole(name, role, data) {
  return request(`/application/${name}/role/${role}`, {
    method: 'put',
    data
  })
}

function removeApplicationRole(name, role) {
  return request(`/application/${name}/role/${role}`, {
    method: 'delete'
  })
}

function changeApplicationMember(name, group, data) {
  return request(`/application/${name}/member/${group}`, {
    method: 'put',
    data
  })
}

function removeApplicationMember(name, group) {
  return request(`/application/${name}/member/${group}`, {
    method: 'delete'
  })
}

function changeApplicationPermission(name, permission, data) {
  return request(`/application/${name}/permission/${permission}`, {
    method: 'put',
    data
  })
}

function removeApplicationPermission(name, permission) {
  return request(`/application/${name}/permission/${permission}`, {
    method: 'delete'
  })
}

function createApplicationPackage(name, formData, cb) {
  return request(`/application/${name}/package`, {
    method: 'post',
    requestType: 'form',
    body: formData,
    onReqProgress: function (ev) {
      let percent = parseInt((ev?.loaded / ev?.total) * 100)
      cb?.(percent)
    }
  })
}

function activateApplicationPackage(applicationName, packageName) {
  return request(
    `/application/${applicationName}/package/${packageName}/activate`,
    {
      method: 'put'
    }
  )
}

function deleteApplicationPackage(applicationName, packageName) {
  return request(`/application/${applicationName}/package/${packageName}`, {
    method: 'delete'
  })
}

function authenticate(data) {
  return request(`/auth/token`, {
    method: 'post',
    data
  })
}

function userLogin(data) {
  return request(`/auth/login`, {
    method: 'post',
    data
  })
}

function userLogout(username) {
  return request(`/auth/logout`, {
    method: 'post',
    data: {
      username
    }
  })
}

function getAuthMethods() {
  return request(`/auth/method`, {
    method: 'get'
  })
}

function getCaptcha() {
  return request(`/auth/captcha`, {
    method: 'get'
  })
}

function providerAuthorize(provider) {
  return request(`/auth/provider/${provider}/authorize`, {
    method: 'get'
  })
}

function providerToken(provider, code) {
  return request(`/auth/provider/${provider}/token?code=${code}`, {
    method: 'get'
  })
}

function providerProfile(provider, token) {
  return request(`/auth/provider/${provider}/profile?token=${token}`, {
    method: 'get'
  })
}

function queryViews(page, page_size, filter = {}, status) {
  return request('/view/query', {
    method: 'post',
    data: {
      page,
      page_size,
      filter,
      status
    }
  })
}

function getView(name) {
  return request(`/view/${name}`, {
    method: 'get'
  })
}

function createView(data) {
  return request('/view', {
    method: 'post',
    data
  })
}

function updateView(name, data) {
  return request(`/view/${name}`, {
    method: 'put',
    data
  })
}

function removeView(name, force = false) {
  return request(`/view/${name}${force ? '?force=1' : ''}`, {
    method: 'delete'
  })
}

function restoreView(name) {
  return request(`/view/${name}/restore`, {
    method: 'put'
  })
}

function executeView(name, data) {
  return request(`/view/${name}/execute`, {
    method: 'post',
    data
  })
}

function queryTemplates(page, page_size, filter = {}, status) {
  return request('/template/query', {
    method: 'post',
    data: {
      page,
      page_size,
      filter,
      status
    }
  })
}

function getTemplate(name) {
  return request(`/template/${name}`, {
    method: 'get'
  })
}

function createTemplate(data) {
  return request('/template', {
    method: 'post',
    data
  })
}

function updateTemplate(name, data) {
  return request(`/template/${name}`, {
    method: 'put',
    data
  })
}

function removeTemplate(name, force = false) {
  return request(`/template/${name}${force ? '?force=1' : ''}`, {
    method: 'delete'
  })
}

function restoreTemplate(name) {
  return request(`/template/${name}/restore`, {
    method: 'put'
  })
}

function queryRuleSets(page, page_size, filter = {}, status) {
  return request('/rule/set/query', {
    method: 'post',
    data: {
      page,
      page_size,
      filter,
      status
    }
  })
}

function getRuleSet(name) {
  return request(`/rule/set/${name}`, {
    method: 'get'
  })
}

function createRuleSet(data) {
  return request('/rule/set', {
    method: 'post',
    data
  })
}

function updateRuleSet(name, data) {
  return request(`/rule/set/${name}`, {
    method: 'put',
    data
  })
}

function removeRuleSet(name, force = false) {
  return request(`/rule/set/${name}${force ? '?force=1' : ''}`, {
    method: 'delete'
  })
}

function restoreRuleSet(name) {
  return request(`/rule/set/${name}/restore`, {
    method: 'put'
  })
}

function queryRules(page, page_size, filter = {}, status) {
  return request('/rule/query', {
    method: 'post',
    data: {
      page,
      page_size,
      filter,
      status
    }
  })
}

function getRule(name) {
  return request(`/rule/${name}`, {
    method: 'get'
  })
}

function createRule(data) {
  return request('/rule', {
    method: 'post',
    data
  })
}

function updateRule(name, data) {
  return request(`/rule/${name}`, {
    method: 'put',
    data
  })
}

function removeRule(name, force = false) {
  return request(`/rule/${name}${force ? '?force=1' : ''}`, {
    method: 'delete'
  })
}

function restoreRule(name) {
  return request(`/rule/${name}/restore`, {
    method: 'put'
  })
}

function queryTasks(page, page_size, filter = {}, status = null) {
  return request('/task/query', {
    method: 'post',
    data: {
      page,
      page_size,
      filter,
      status
    }
  })
}

function getTask(name) {
  return request(`/task/${name}`, {
    method: 'get'
  })
}

function createTask(data) {
  return request('/task', {
    method: 'post',
    data
  })
}

function updateTask(name, data) {
  return request(`/task/${name}`, {
    method: 'put',
    data
  })
}

function removeTask(name, force = false) {
  return request(`/task/${name}${force ? '?force=1' : ''}`, {
    method: 'delete'
  })
}

function restoreTask(name) {
  return request(`/task/${name}/restore`, {
    method: 'put'
  })
}

function enableTask(name) {
  return request(`/task/${name}/enable`, {
    method: 'put'
  })
}

function disableTask(name) {
  return request(`/task/${name}/disable`, {
    method: 'put'
  })
}

function setTaskData(name, data) {
  return request(`/task/${name}/data`, {
    method: 'put',
    data
  })
}

function getTaskJob(name) {
  return request(`/task/job/${name}`, {
    method: 'get'
  })
}

function getAction(name) {
  return request(`/action/${name}`, {
    method: 'get'
  })
}

function createAction(data) {
  return request('/action', {
    method: 'post',
    data
  })
}

function updateAction(name, data) {
  return request(`/action/${name}`, {
    method: 'put',
    data
  })
}

function executeAction(name, data) {
  return request(`/action/execute/${name}`, {
    method: 'post',
    data
  })
}

function exacteActionFunction(action, fname, data) {
  return request(`/notice/customer/${action}/action/${fname}`, {
    method: 'put',
    data
  })
}

function uploadActionScript(file, name = null) {
  const formData = new FormData()
  formData.append('file', file)

  if (name) {
    formData.append('name', name)
  }

  return request('/action/upload', {
    method: 'post',
    requestType: 'form',
    body: formData
  })
}

function removeAction(name, force = false) {
  return request(`/action/${name}${force ? '?force=1' : ''}`, {
    method: 'delete'
  })
}

function queryActions(page, page_size, filter = {}, status = null) {
  return request('/action/query', {
    method: 'post',
    data: {
      page,
      page_size,
      filter,
      status
    }
  })
}

function getActionJob(name) {
  return request(`/action/job/${name}`, {
    method: 'get'
  })
}

function getPackage() {
  return request(`/package`, {
    method: 'get'
  })
}

function currentPackage() {
  return request(`/package/manifest`, {
    method: 'get'
  })
}

function createPackage(formData, cb) {
  return request('/package', {
    method: 'post',
    requestType: 'form',
    body: formData,
    onReqProgress: function (ev) {
      let percent = parseInt((ev?.loaded / ev?.total) * 100)
      cb?.(percent)
    }
  })
}

function activatePackage(name) {
  return request(`/package/activate/${name}`, {
    method: 'put'
  })
}

function deletePackage(name) {
  return request(`/package/${name}`, {
    method: 'delete'
  })
}

function importTags(tags) {
  return request('/tag/import', {
    method: 'post',
    data: {
      tags
    }
  })
}

function queryTags({ page, page_size, keyword, groups, filter, status }) {
  return request('/tag/query', {
    method: 'post',
    data: {
      page,
      page_size,
      keyword,
      groups,
      filter,
      status
    }
  })
}

function getTag(name) {
  return request(`/tag/${name}`, {
    method: 'get'
  })
}

function createTag(data) {
  return request('/tag', {
    method: 'post',
    data
  })
}

function updateTag(name, data) {
  return request(`/tag/${name}`, {
    method: 'put',
    data
  })
}

function removeTag(name, force = false) {
  return request(`/tag/${name}${force ? '?force=1' : ''}`, {
    method: 'delete'
  })
}

function restoreTag(name) {
  return request(`/tag/${name}/restore`, {
    method: 'put'
  })
}

function getTagGroup() {
  return request(`/tag/group`, {
    method: 'get'
  })
}

function sendEmail(data) {
  return request(`/message/email`, {
    method: 'post',
    data
  })
}

function connectorTest(data) {
  return request(`/connector/test`, {
    method: 'post',
    data
  })
}

function connectorList(data) {
  return request(`/connector/list`, {
    method: 'post',
    data
  })
}

function connectorInspect(data) {
  return request(`/connector/inspect`, {
    method: 'post',
    data
  })
}

function connectorCount(data) {
  return request(`/connector/count`, {
    method: 'post',
    data
  })
}

function connectorSelect(data) {
  return request(`/connector/select`, {
    method: 'post',
    data
  })
}

function connectorExecute(data) {
  return request(`/connector/execute`, {
    method: 'post',
    data
  })
}

function querySources(query) {
  return request(`/connector/manage/query`, {
    method: 'post',
    query
  })
}

function getSource(name) {
  return request(`/connector/manage/${name}`, {
    method: 'get'
  })
}

function createSource(data) {
  return request(`/connector/manage`, {
    method: 'post',
    data
  })
}

function updateSource(name, data) {
  return request(`/connector/manage/${name}`, {
    method: 'put',
    data
  })
}

function removeSource(name) {
  return request(`/connector/manage/${name}`, {
    method: 'delete'
  })
}

function addSourceQuery(sourceName, data = {}) {
  return request(`/connector/manage/${sourceName}/query`, {
    method: 'post',
    data
  })
}

function updateSourceQuery(sourceName, queryName, data = {}) {
  return request(`/connector/manage/${sourceName}/query/${queryName}`, {
    method: 'put',
    data
  })
}

function deleteSourceQuery(sourceName, queryName) {
  return request(`/connector/manage/${sourceName}/query/${queryName}`, {
    method: 'delete'
  })
}

function executeSourceQuery(sourceName, queryName) {
  return request(`/connector/manage/${sourceName}/query/${queryName}`, {
    method: 'get'
  })
}

function queryAuditLogs(data) {
  return request(`/system/audit`, {
    method: 'post',
    data
  })
}

function queryAction(route, data) {
  return request(`/action/execute/${route}`, {
    method: 'post',
    data
  })
}

// category
function queryCategories(query) {
  return request('/category/query', {
    method: 'post',
    data: query
  })
}

function loadCategory(name) {
  return request(`/category/${name}`, {
    method: 'get'
  })
}

function createCategory(data) {
  return request('/category', {
    method: 'post',
    data
  })
}

function removeCategory(name, force = false) {
  return request(`/category/${name}${force ? '?force=1' : ''}`, {
    method: 'delete'
  })
}

function updateCategory(name, data) {
  return request(`/category/${name}`, {
    method: 'put',
    data
  })
}

// client
function queryClients(query) {
  return request('/client/query', {
    method: 'post',
    data: query
  })
}

function loadClient(name) {
  return request(`/client/${name}`, {
    method: 'get'
  })
}

function createClient(data) {
  return request('/client', {
    method: 'post',
    data
  })
}

function removeClient(name, force = false) {
  return request(`/client/${name}${force ? '?force=1' : ''}`, {
    method: 'delete'
  })
}

function updateClient(name, data) {
  return request(`/client/${name}`, {
    method: 'put',
    data
  })
}

function executeEndpoint(params = {}) {
  return request(`/client/${params.clientName}/call/${params.endpointName}`, {
    method: params.method,
    data: params.data || undefined
  })
}

// spider
function querySpider(page, page_size, filter = {}, status) {
  return request('/spider/query', {
    method: 'post',
    data: {
      page,
      page_size,
      filter,
      status
    }
  })
}

function getSpider(name) {
  return request(`/spider/${name}`, {
    method: 'get'
  })
}

function createSpider(data) {
  return request('/spider', {
    method: 'post',
    data
  })
}

function updateSpider(name, data) {
  return request(`/spider/${name}`, {
    method: 'put',
    data
  })
}

function removeSpider(name, force = false) {
  return request(`/spider/${name}${force ? '?force=1' : ''}`, {
    method: 'delete'
  })
}

function getSearchEngineInfo() {
  return request('search/info', {
    method: 'get'
  })
}

function querySearchIndex() {
  return request('/search/index', {
    method: 'get'
  })
}

function getSearchIndex(name) {
  return request(`/search/index/${name}`, {
    method: 'get'
  })
}

function removeSearchIndex(name) {
  return request(`/search/index/${name}`, {
    method: 'delete'
  })
}

function createSearchIndex(name) {
  return request(`/search/index`, {
    method: 'post',
    data: {
      subject: name
    }
  })
}

function updateSearchIndex(name) {
  return request(`/search/index/${name}`, {
    method: 'put'
  })
}

function queryDictList(data) {
  return request('/search/service/dict', {
    method: 'post',
    data
  })
}

function analyzeText(data) {
  return request('/search/analyze', {
    method: 'post',
    data
  })
}

function updateDictList(data) {
  return request('/search/service/dict-update', {
    method: 'post',
    data
  })
}

function getMcpList(data) {
  return request('/mcp', {
    method: 'get'
  })
}

function queryMcps(query) {
  return request('/mcp/query', {
    method: 'post',
    data: query
  })
}

function getMcp(name) {
  return request(`/mcp/${name}`, {
    method: 'get'
  })
}

function createMcp(data) {
  return request('/mcp', {
    method: 'post',
    data
  })
}

function updateMcp(name, data) {
  return request(`/mcp/${name}`, {
    method: 'put',
    data
  })
}

function removeMcp(name, force = false) {
  return request(`/mcp/${name}${force ? '?force=1' : ''}`, {
    method: 'delete'
  })
}

function getMcpDetail(name) {
  return request(`/mcp/${name}`, {
    method: 'get'
  })
}

async function getMcpTools(name) {
  try {
    const client = new Client({
      name: 'streamable-http-client',
      version: '1.0.0'
    })
    const transport = new StreamableHTTPClientTransport(
      `${baseUrl}/mcp/${name}`
    )
    await client.connect(transport)
    console.log('connect')
    return await client.listTools()
  } catch (error) {
    console.error('Error connecting to MCP tools:', error)
    throw error // 重新抛出错误，以便调用者可以处理
  }
}

async function callMcpTool(mcpName, toolName, data = {}) {
  try {
    const client = new Client({
      name: 'streamable-http-client',
      version: '1.0.0'
    })
    const transport = new StreamableHTTPClientTransport(
      `${baseUrl}/mcp/${mcpName}`
    )
    await client.connect(transport)
    return await client.callTool({
      name: toolName,
      arguments: data
    })
  } catch (error) {
    console.error('Error connecting to MCP tools:', error)
    throw error // 重新抛出错误，以便调用者可以处理
  }
}

// Notice
function queryNotice(page, page_size, filter = {}, status) {
  return request('/notice/query', {
    method: 'post',
    data: {
      page,
      page_size,
      filter,
      status
    }
  })
}

// 详情
function getNotice(name) {
  return request(`/notice/${name}`, {
    method: 'get'
  })
}
// 创建
function createNotice(data) {
  return request(`/notice`, {
    method: 'post',
    data
  })
}

function sendNotice(name) {
  return request(`/notice/${name}/send`, {
    method: 'put'
  })
}

// 更新
function updateNotice(name, data) {
  return request(`/notice/${name}`, {
    method: 'put',
    data
  })
}
//删除
function removeNotice(name, force = false) {
  return request(`/notice/${name}`, {
    method: 'delete'
  })
}
// 禁用
function disableNotice(name) {
  return request(`/notice/${name}/disable`, {
    method: 'put'
  })
}
// 启用
function enableNotice(name) {
  return request(`/notice/${name}/enable`, {
    method: 'put'
  })
}

// Trigger
// 列表
function queryTrigger(page, page_size, filter = {}, status) {
  return request('/trigger/query', {
    method: 'post',
    data: {
      page,
      page_size,
      filter,
      status
    }
  })
}

// 详情
function getTrigger(name) {
  return request(`/trigger/${name}`, {
    method: 'get'
  })
}
// 创建
function createTrigger(data) {
  return request(`/trigger`, {
    method: 'post',
    ContentType: 'applicaton/json',
    data
  })
}
// 更新
function updateTrigger(name, data) {
  return request(`/trigger/${name}`, {
    method: 'put',
    ContentType: 'applicaton/json',
    data
  })
}
//删除
function removeTrigger(name, force = false) {
  return request(`/trigger/${name}`, {
    method: 'delete'
  })
}
// 禁用
function disableTrigger(name) {
  return request(`/trigger/${name}/disable`, {
    method: 'put'
  })
}
// 启用
function enableTrigger(name) {
  return request(`/trigger/${name}/enable`, {
    method: 'put'
  })
}

// Variable
//  {page,page_size,filter,status}
function queryVariable(page, page_size, filter = {}, status) {
  return request('/variable/query', {
    method: 'post',
    data: {
      page,
      page_size,
      filter,
      status
    }
  })
}
// 详情
function getVariable(name) {
  return request(`/variable/${name}`, {
    method: 'get'
  })
}
// 创建
function createVariable(data) {
  return request(`/variable`, {
    method: 'post',
    data
  })
}
// 更新
function updateVariable(name, data) {
  return request(`/variable/${name}`, {
    method: 'put',
    data
  })
}
//删除
function removeVariable(name, force = false) {
  return request(`/Variable/${name}`, {
    method: 'delete'
  })
}
// 禁用
function disableVariable(name) {
  return request(`/Variable/${name}/disable`, {
    method: 'put'
  })
}
// 启用
function enableVariable(name) {
  return request(`/variable/${name}/enable`, {
    method: 'put'
  })
}

// dynamicForm
// 表单列表
function queryDForm(page, page_size, filter = {}, status = null, sort = null) {
  return request('/form/query', {
    method: 'post',
    data: {
      page,
      page_size,
      filter,
      status,
      sort
    }
  })
}

// 创建表单
function createDForm(data) {
  return request('/form', {
    method: 'post',
    data
  })
}

// 更新表单
function updateDForm(name, data) {
  return request(`/form/${name}`, {
    method: 'put',
    data
  })
}

// 删除表单
function removeDForm(name) {
  return request(`/form/${name}`, {
    method: 'delete'
  })
}

// 查询表单详情
function getDFormDetail(name) {
  return request(`/form/${name}`, {
    method: 'get'
  })
}

// 创建表单字段
function createDFormField(name, data) {
  return request(`/form/${name}/field`, {
    method: 'post',
    data
  })
}

// 更新表单字段
function updateDFormField(name, fieldName, data) {
  return request(`/form/${name}/field/${fieldName}`, {
    method: 'put',
    data
  })
}

// 删除表单字段
function removeDFormField(name, fieldName) {
  return request(`/form/${name}/field/${fieldName}`, {
    method: 'delete'
  })
}

// 表单字段排序
function sortDFormField(name, data) {
  return request(`/form/${name}/field/reorder`, {
    method: 'put',
    data
  })
}

// 导入表单字段
function importDFormField(name, data) {
  return request(`/form/${name}/field/import`, {
    method: 'put',
    data
  })
}

// 获取表单指定字段
function getDFormField(name, fieldName) {
  return request(`/form/${name}/field/${fieldName}`, {
    method: 'get'
  })
}

// 获取指定表单所有字段
function getDFormFields(name) {
  return request(`/form/${name}/field`, {
    method: 'get'
  })
}

// 对象带有动态表单创建记录
function createRecordWithDForm(data) {
  return request(`/record`, {
    method: 'post',
    data
  })
}

// 消息获取
function queryUserNotice(page, page_size, filter = {}, status = null) {
  // https://www.streams7.com/api/notice/customer/query
  return request('/notice/customer/query', {
    method: 'post',
    data: {
      page,
      page_size,
      filter,
      status
    }
  })
}

function readUserNotice(name) {
  return request('/notice/customer/read', {
    method: 'put',
    data: {
      name
    }
  })
}

// function sendNotice(name) {
//   return request(`/notice/${name}/send`, {
//     method: 'put'
//   })
// }
// function readUserNotice() {
//   return request('/notice/customer/read', {
//     method: 'put'
//   })
// }

function unReadNoticeCount() {
  return request('/notice/customer/count', {
    method: 'get'
  })
}

// 消息清空
function cleanUserNotice(name) {
  return request('/notice/customer/clean', {
    method: 'put',
    data: {
      name
    }
  })
}



// tracking

/**
 *
 * @param {*} query  {page, page_size, event, user_id, path, start_date, end_date}
 * @returns
 */
function queryTracking(query = {}) {
  return request('/tracking/query', {
    method: 'post',
    data: query
  })
}


function createTracking(data) {
  return request('/tracking', {
    method: 'post',
    data
  })
}

function getTracking(id) {
  return request(`/tracking/${id}`, {
    method: 'get'
  })
}


export {
  activateApplicationPackage,
  activatePackage,
  addGroupUser,
  addSubjectField,
  aggregateRecords,
  aggregateSearch,
  //auth
  authenticate,
  batchCreateRecords,
  batchRemoveRecords,
  batchUpdateRecords,
  changeApplicationMember,
  changeApplicationPermission,
  changeApplicationRole,
  changePassword,
  changeSearchIndex,
  clearRecords,
  cloneRecord,
  commonSearch,
  connectorCount,
  connectorExecute,
  connectorInspect,
  connectorList,
  connectorSelect,
  //connector,
  connectorTest,
  countRecords,
  createAction,
  createApplication,
  createApplicationPackage,
  createCategory,
  createClient,
  createDocument,
  createGroup,
  createPackage,
  createRecord,
  createRecordMember,
  createRule,
  createRuleSet,
  createSearchIndex,
  createSpider,
  createSubject,
  createTag,
  createTask,
  createTemplate,
  createUser,
  createView,
  currentPackage,
  deleteApplicationPackage,
  deletePackage,
  deleteSubjectField,
  disableTask,
  disableUser,
  enableTask,
  enableUser,
  executeAction,
  exacteActionFunction,
  executeEndpoint,
  executeView,
  generateTicket,
  // action
  getAction,
  getActionJob,
  //application
  getApplications,
  getAuthMethods,
  getCaptcha,
  getDocument,
  getGroup,
  // package
  getPackage,
  getRecordMembers,
  getRule,
  getRuleSet,
  // 搜索引擎信息
  getSearchEngineInfo,
  getSearchIndex,
  getSpider,
  //fields
  getSubjectField,
  getSubjectIndex,
  getSystemInfo,
  getTag,
  getTagGroup,
  getTask,
  getTaskJob,
  getTemplate,
  getUserInfo,
  getView,
  importRecords,
  importSubjectFields,
  // tag
  importTags,
  importUsers,
  initializeSystem,
  langChainChat,
  langChainChatWithRag,
  llmList,
  llmChat,
  loadApplication,
  loadCategory,
  loadClient,
  // record
  loadRecord,
  loadRecords,
  loadRecordRevisions,
  applyRecordRevision,
  //subject
  loadSubject,
  loadSubjects,
  loadUser,
  ollamaChat,
  ollamaList,
  ollamaPull,
  ollamaRemove,
  ollamaShow,
  //subjectView
  getSubjectView,
  getSubjectViewDetail,
  createSubjectView,
  updateSubjectView,
  deleteSubjectView,
  reorderSubjectView,
  // patch
  patchRecord,
  providerAuthorize,
  providerProfile,
  providerToken,
  proxyGet,
  putSystemInfo,
  putUserInfo,
  queryAction,
  queryActions,
  queryApplications,
  queryAuditLogs,
  // category
  queryCategories,
  // client
  queryClients,
  // document
  queryDocuments,
  //group,
  queryGroups,
  queryRecords,
  queryRemovedRecord,
  //rule
  queryRules,
  //ruleSet
  queryRuleSets,
  querySearchIndex,
  //spider
  querySpider,
  querySubjects,
  queryTags,
  //task
  queryTasks,
  //template
  queryTemplates,
  //users
  queryUsers,
  //view
  queryViews,
  refreshSubjectIndex,
  removeAction,
  removeApplication,
  removeApplicationMember,
  removeApplicationPermission,
  removeApplicationRole,
  removeCategory,
  removeClient,
  removeDocument,
  removeGroup,
  removeGroupUser,
  removeRecord,
  removeRecordMember,
  removeRule,
  removeRuleSet,
  removeSearchIndex,
  removeSpider,
  removeSubject,
  removeTag,
  removeTask,
  removeTemplate,
  removeUser,
  removeView,
  reorderRecords,
  reorderSubjectField,
  restoreApplication,
  restoreDocument,
  restoreRecord,
  restoreRule,
  restoreRuleSet,
  restoreSubject,
  restoreTag,
  restoreTask,
  restoreTemplate,
  restoreView,
  rrfSearch,
  semanticSearch,
  search,
  //message
  sendEmail,
  setTaskData,
  subjectSearch,
  queryAnalyze,
  documentAnalyze,
  imageAnalyze,
  documentRerank,
  webSearch,
  updateAction,
  updateApplication,
  updateCategory,
  updateClient,
  updateDocument,
  updateGroup,
  updateRecord,
  updateRecordMember,
  updateRule,
  updateRuleSet,
  updateSearchIndex,
  updateSpider,
  updateSubject,
  updateSubjectField,
  updateTag,
  updateTask,
  updateTemplate,
  updateUser,
  updateView,
  uploadActionScript,
  uploadDocument,
  uploadFile,
  userLogin,
  userLogout,
  vectorSearch,
  updateDictList,
  queryDictList,
  analyzeText,
  // mcp
  getMcpList,
  getMcpDetail,
  getMcpTools,
  callMcpTool,
  getMcp,
  queryMcps,
  removeMcp,
  createMcp,
  updateMcp,
  // trigger
  createTrigger,
  queryTrigger,
  updateTrigger,
  removeTrigger,
  disableTrigger,
  enableTrigger,
  getTrigger,
  // variable
  queryVariable,
  createVariable,
  getVariable,
  updateVariable,
  removeVariable,
  enableVariable,
  disableVariable,
  // form
  queryDForm,
  createDForm,
  updateDForm,
  removeDForm,
  // form field
  getDFormDetail,
  createDFormField,
  updateDFormField,
  removeDFormField,
  sortDFormField,
  getDFormField,
  getDFormFields,
  importDFormField,
  createRecordWithDForm,
  // Notice
  queryNotice,
  createNotice,
  enableNotice,
  disableNotice,
  getNotice,
  removeNotice,
  updateNotice,
  queryUserNotice,
  cleanUserNotice,
  readUserNotice,
  sendNotice,
  unReadNoticeCount,
  querySources,
  getSource,
  createSource,
  updateSource,
  removeSource,
  addSourceQuery,
  updateSourceQuery,
  deleteSourceQuery,
  executeSourceQuery,
  queryTracking,
  createTracking,
  getTracking
}
